import { render, staticRenderFns } from "./CommissionSheet.vue?vue&type=template&id=2210ff10&"
import script from "./CommissionSheet.vue?vue&type=script&lang=js&"
export * from "./CommissionSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports